<template>
  <div id="PersonalInfo">
    <ul class="list">
      <li class="list_item">
        <div class="title">
          <div class="left">登录密码</div>
          <div class="right" @click="jumpTo(1)">修改</div>
        </div>
        <div class="text">
          建议您常修改密码，以保证账号更加安全
        </div>
      </li>
      <li class="list_item">
        <div class="title">
          <div class="left">手机号码</div>
          <div class="right" v-if="!user.mobile" @click="jumpTo(2)">绑定</div>
          <div class="right" v-else @click="jumpTo(2)">重新绑定</div>
        </div>
        <div class="text" v-if="!user.mobile">
          未绑定
        </div>
        <div class="text">
          {{ phone }}
        </div>
      </li>
      <li class="list_item">
        <div class="title">
          <div class="left">邮箱</div>
          <div class="right" v-if="!user.email" @click="jumpTo(3)">绑定</div>
          <div class="right" v-else @click="jumpTo(3)">重新绑定</div>
        </div>
        <div class="text" v-if="!user.email">
          未绑定
        </div>
        <div class="text" v-else>
         {{ user.email }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return { };
  },

  computed: {
    ...mapGetters(['personInfo']),
    user () {
      return this.personInfo.user;
    },
    phone () {
      let { personInfo: { user: { mobile } } } = this;
      return mobile ? mobile.substring(0, 3) + '****' + mobile.substring(7, 11) : '';
    }
  },

  methods: {
    jumpTo (type) {
      const { $router } = this;
      $router.push({
        name: 'UpdataUser',
        params: {
          type
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
  #PersonalInfo{
    padding:0 28px;
    .list{
      .list_item{
        color: #333444;
        font-size: 28px;
        padding: 36px 0;
        border-bottom: 1px solid#EEEEEE;
        .title{
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .right{
            color: #5FA9FF;
          }
        }
        .text{
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
  }
</style>
